'use client';

import { useCallback, useState } from 'react';

interface UseLoading {
  isLoading: boolean;
  startLoading(): void;
  stopLoading(): void;
}

export function useLoading(initialValue = false): UseLoading {
  const [isLoading, setIsLoading] = useState<boolean>(initialValue);

  const startLoading = useCallback(() => setIsLoading(true), []);
  const stopLoading = useCallback(() => setIsLoading(false), []);

  return { isLoading, startLoading, stopLoading };
}
